import { render, staticRenderFns } from "./AppealsDetail.vue?vue&type=template&id=2575f253&"
import script from "./AppealsDetail.vue?vue&type=script&lang=js&"
export * from "./AppealsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppealsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports